import AuditSignalsRoute from '@/features/admin/audit-signals/AuditSignalsRoute.tsx';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/audit-signals')({
  component: AuditSignalsRoute,
});
